export default __webpack_public_path__ + "static/contact_bigg-f9d678ff6b0b960a699aa09ae93271c2.png";